import { Badge, Spinner } from '@/components/ui'

/**
 * running → spinner + "running" (info), passed → green, failed → red,
 * error (replay crashed — infrastructure, not a graded red) → amber,
 * never run → neutral.
 */
export function RunStatusBadge({ status }: { status: string | null }) {
  if (!status) return <Badge variant="secondary">never run</Badge>
  if (status === 'running')
    return (
      <Badge variant="info" className="gap-1">
        <Spinner size="sm" aria-hidden="true" />
        running
      </Badge>
    )
  if (status === 'passed') return <Badge variant="success">passed</Badge>
  if (status === 'failed') return <Badge variant="destructive">failed</Badge>
  if (status === 'error') return <Badge variant="warning">error</Badge>
  return <Badge variant="secondary">{status}</Badge>
}
